import logger from "lib/utils/logger"

export function convertStringToRatio(ratioString: string): number | undefined {
  if (typeof ratioString !== "string") {
    logger.error("Invalid ratio format")
    return undefined
  }
  const parts = ratioString.split(":") || ["2", "3"]

  // Ensure we have exactly two parts
  if (parts.length !== 2) {
    logger.error("Invalid ratio format")
    return undefined
  }

  const numerator = parseInt(parts[0] ?? "")
  const denominator = parseInt(parts[1] ?? "")

  // Check if parsing was successful and denominator is not zero
  if (!isNaN(numerator) && !isNaN(denominator) && denominator !== 0) {
    return numerator / denominator
  } else {
    logger.error("Invalid ratio format")
    return undefined
  }
}

export function getIdFromGid(gid: string | undefined): string {
  if (!gid) return ""

  const arr = gid.split("/")
  const id = arr[arr.length - 1] || ""
  return id
}

export function gidFromId(id: string) {
  if (id.startsWith("gid://shopify/Product/")) return id
  return `gid://shopify/Product/${id}`
}

export function gidFromVariantId(id: string) {
  if (id.startsWith("gid://shopify/ProductVariant/")) return id
  return `gid://shopify/ProductVariant/${id}`
}

export function transformAuthor(author: string) {
  const [first, last = ""] = author?.split(" ") || []
  return first ? `${first}${last ? ` ${last.charAt(0)}.` : ""}` : ""
}
